"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _addByDatasetButton = _interopRequireDefault(require("../add-by-dataset-button"));

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project
function AddLayerButtonFactory() {
  var AddLayerButton = function AddLayerButton(_ref) {
    var datasets = _ref.datasets,
        onAdd = _ref.onAdd;
    return /*#__PURE__*/_react["default"].createElement(_addByDatasetButton["default"], {
      datasets: datasets,
      className: "add-layer-button",
      width: "110px",
      onAdd: onAdd,
      buttonIntlId: "layerManager.addLayer"
    });
  };

  return AddLayerButton;
}

var _default = AddLayerButtonFactory;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zaWRlLXBhbmVsL2xheWVyLXBhbmVsL2FkZC1sYXllci1idXR0b24udHN4Il0sIm5hbWVzIjpbIkFkZExheWVyQnV0dG9uRmFjdG9yeSIsIkFkZExheWVyQnV0dG9uIiwiZGF0YXNldHMiLCJvbkFkZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBR0E7O0FBQ0E7O0FBSkE7QUFDQTtBQVdBLFNBQVNBLHFCQUFULEdBQWlDO0FBQy9CLE1BQU1DLGNBQTZDLEdBQUcsU0FBaERBLGNBQWdELE9BQXVCO0FBQUEsUUFBckJDLFFBQXFCLFFBQXJCQSxRQUFxQjtBQUFBLFFBQVhDLEtBQVcsUUFBWEEsS0FBVztBQUMzRSx3QkFDRSxnQ0FBQyw4QkFBRDtBQUNFLE1BQUEsUUFBUSxFQUFFRCxRQURaO0FBRUUsTUFBQSxTQUFTLEVBQUMsa0JBRlo7QUFHRSxNQUFBLEtBQUssRUFBQyxPQUhSO0FBSUUsTUFBQSxLQUFLLEVBQUVDLEtBSlQ7QUFLRSxNQUFBLFlBQVksRUFBQztBQUxmLE1BREY7QUFTRCxHQVZEOztBQVlBLFNBQU9GLGNBQVA7QUFDRDs7ZUFDY0QscUIiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBTUERYLUxpY2Vuc2UtSWRlbnRpZmllcjogTUlUXG4vLyBDb3B5cmlnaHQgY29udHJpYnV0b3JzIHRvIHRoZSBrZXBsZXIuZ2wgcHJvamVjdFxuXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IEFkZEJ5RGF0YXNldEJ1dHRvbiBmcm9tICcuLi9hZGQtYnktZGF0YXNldC1idXR0b24nO1xuaW1wb3J0IHtEYXRhc2V0c30gZnJvbSAnQGtlcGxlci5nbC90YWJsZSc7XG5cbmV4cG9ydCB0eXBlIEFkZExheWVyQnV0dG9uUHJvcHMgPSB7XG4gIGRhdGFzZXRzOiBEYXRhc2V0cztcbiAgb25BZGQ6IChkYXRhSWQ6IHN0cmluZykgPT4gdm9pZDtcbn07XG5cbmZ1bmN0aW9uIEFkZExheWVyQnV0dG9uRmFjdG9yeSgpIHtcbiAgY29uc3QgQWRkTGF5ZXJCdXR0b246IFJlYWN0LkZDPEFkZExheWVyQnV0dG9uUHJvcHM+ID0gKHtkYXRhc2V0cywgb25BZGR9KSA9PiB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxBZGRCeURhdGFzZXRCdXR0b25cbiAgICAgICAgZGF0YXNldHM9e2RhdGFzZXRzfVxuICAgICAgICBjbGFzc05hbWU9XCJhZGQtbGF5ZXItYnV0dG9uXCJcbiAgICAgICAgd2lkdGg9XCIxMTBweFwiXG4gICAgICAgIG9uQWRkPXtvbkFkZH1cbiAgICAgICAgYnV0dG9uSW50bElkPVwibGF5ZXJNYW5hZ2VyLmFkZExheWVyXCJcbiAgICAgIC8+XG4gICAgKTtcbiAgfTtcblxuICByZXR1cm4gQWRkTGF5ZXJCdXR0b247XG59XG5leHBvcnQgZGVmYXVsdCBBZGRMYXllckJ1dHRvbkZhY3Rvcnk7XG4iXX0=